<template>
  <div class="playlet">
    <el-card>
      <el-button
        size="mini"
        type="success"
        icon="el-icon-s-help"
        style="float: right;margin-bottom:10px"
        @click="add"
      >创建</el-button>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="path"
            label="地址"
            width="500"
            align="center"
          />
          <el-table-column
            prop="admin_name"
            label="创建人"
            width="200"
            align="center"
          />
          <el-table-column
            prop="create_at_text"
            label="创建时间"
            width="300"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="warning"
                size="small"
                @click="chooser(scope.row)"
              >选择</el-button>
            </template>
          </el-table-column></el-table>
      </div>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { settinglist } from '@/api/sourceminiprogram.js'
export default {
  name: 'CpsopTion',
  components: {
    PaginationRight
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10
      },
      loading: false,
      tableData: [],
      total: null,
      cookiedialogVisible: false
    }
  },

  created() {
    // this.getDatas()
  },
  activated() {
    // this.getDatas()
  },
  mounted() {},
  methods: {
    add() {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(1)
      })
    },
    edit(item) {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(2, item)
      })
    },
    async getDatas() {
      this.loading = true
      const data = await settinglist(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10
      }
      this.getDatas()
    },

    updatar() {
      this.cookiedialogVisible = false
      this.getDatas()
    },
    send() {
      this.getDatas()
    },
    chooser(item) {
      this.$emit('callbackcps', item)
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-card {
  height: 70px;
}
</style>

